import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

type Props = {
	title: string;
	time: string;
	className?: string;
	key?: string;
};

export const ActivityPill: React.FC<Props> = ({ title, time, className, ...rest }) => {
	return (
		<div
			className={cn(
				'rounded-medium bg-fill-accent-primary-weaker inline-flex h-12 items-center gap-1 px-[11px] py-2',
				className,
			)}
			{...rest}
		>
			<Text data-nosnippet variant="body" size="x-small">
				{title}
			</Text>
			<Text variant="body" size="x-small">
				•
			</Text>
			<Text variant="body" size="x-small">
				{time}
			</Text>
		</div>
	);
};
